import validate from 'validate.js';

const validateCleaningFeeRateForm = (cleaningFeeRate) => {
  return validate.single(cleaningFeeRate,
    {
      presence: { allowEmpty: false },
      numericality: {
        onlyInteger: true,
        greaterThan: 0
      }
    });
};

export default validateCleaningFeeRateForm;
